import styled from 'styled-components';
import { Button, lightenDarkenColor } from '../shared/utils/styles';

export const Container = styled.div`
  & button {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 7px 12px;
    height: 50px;
    border: 1px solid gray;
    :disabled {
      cursor: not-allowed;
      background-color: #e7e7e7;
      color: #666;
    }
    & i {
      padding-right: 5px;
      font-size: 1.2em;
    }
  }
`;

export const PauseButton = styled(Button)`
  font-weight: normal;
  background-color: ${(props) => props.bgColor};
  color: ${(props) => props.color};
  &:hover {
    background-color: ${(props) => lightenDarkenColor(props.bgColor, props.bgVariance ?? 20)};
    color: ${(props) => props.color};
  }
`;
